module.exports = __webpack_public_path__ + "static/media/closeup-square.c7e929bc.JPG";